import jwtDecode from 'jwt-decode'
// routes
import { PATH_AUTH } from '../routes/paths'
//
import axios from './axios'

// ----------------------------------------------------------------------

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false
  }
  
  try {
    const decoded = jwtDecode(accessToken)
    const currentTime = Date.now() / 1000
    return decoded.exp > currentTime
  } catch (error) {
    return false
  }
}

const handleTokenExpired = (exp) => {
  let expiredTimer

  const currentTime = Date.now()

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime

  clearTimeout(expiredTimer)

  expiredTimer = setTimeout(() => {
    // Instead of showing alert, let the axios interceptor handle refresh
    // If refresh fails, the interceptor will redirect to login
    console.log('Token expired, attempting refresh...')
  }, timeLeft)
}

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken)
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`

    // This function below will handle when token is expired
    try {
      const { exp } = jwtDecode(accessToken) // ~5 days by minimals server
      handleTokenExpired(exp)
    } catch (error) {
      console.error('Error decoding token:', error)
    }
  } else {
    localStorage.removeItem('accessToken')
    delete axios.defaults.headers.common.Authorization
  }
}

export { isValidToken, setSession }
